export const Server = {
    API_ORIGIN: 'https://api.bilisph.app',
    API_ENDPOINT: '/v2',
}
